/**
 * The finding-id alphabet, shared by the two boundaries that have to agree on it: the
 * client parser that reads ids out of a findings payload, and the proxy that puts one
 * in an upstream URL path segment. Holding both to one pattern means a server-side
 * alphabet change fails at parse time -- the section reports an error once -- instead
 * of rendering ids the proxy then rejects on every action.
 */
export const INVESTIGATION_FINDING_ID_PATTERN = /^[0-9A-Za-z]{1,64}$/
